<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Invite Partners</h5>
      <button
        ref="modalCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <SelectedBackupTR
                @syncBackupTRs="syncBackupTRs"
              ></SelectedBackupTR>
              <div class="selected-drivers">
                <div class="row mt-1">
                  <div class="col-sm-12">
                    <h7 style="float: left; font-weight: 500; font-size: 16px"
                      >Selected Drivers</h7
                    >
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-sm-12">
                    <span
                      v-for="driver in selectedDriverDetails"
                      :key="driver._id"
                      class="badge rounded-pill bg-light text-dark backup-tr-badge"
                      style="margin-right: 5px; margin-bottom: 5px"
                      >{{ driver.user_code }}</span
                    >
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-sm-12">
                    <span
                      class="text-danger"
                      v-if="nullBackupTR && selectedDriverDetails.length > 1"
                      >Multiple drivers can not be assigned for null TR.</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-12">
          <div class="invite-backup-partner-table">
            <table class="table">
              <thead>
                <tr>
                  <th>BR Code</th>
                  <th>Route</th>
                  <th>Regular Price</th>
                  <th>Multiplier %</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tr in selectedBackupTR" :key="tr.id">
                  <td>{{ tr.backup_request_code }}</td>
                  <td>{{ tr.route_name }}</td>
                  <td>{{ tr.price ? tr.price : 'N/A' }}</td>
                  <td>
                    <input
                      type="number"
                      :disabled="nullBackupTR || !tr.price"
                      :class="{
                        'form-control': true,
                        'danger-value':
                          backupRequestData[tr.id].multiplier >= 20
                      }"
                      @keyup="calculateTotal(tr.id)"
                      @change="calculateTotal(tr.id)"
                      v-model="backupRequestData[tr.id].multiplier"
                      step="any"
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      :class="{
                        'form-control': true,
                        'danger-value':
                          backupRequestData[tr.id].multiplier >= 20
                      }"
                      @keyup="calculateMultiplier(tr.id)"
                      @change="calculateMultiplier(tr.id)"
                      v-model="backupRequestData[tr.id].total"
                      step="any"
                    />
                  </td>
                </tr>
                <tr v-if="nullBackupTR">
                  <td colspan="20">
                    <p class="text-danger">
                      This trip doesn't have a trip id. So the bill can not be
                      calculated!
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal-footer"
      v-if="selectedBackupTR && selectedBackupTR.length > 0"
    >
      <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        Loading...
      </button>
      <button
        v-else-if="nullBackupTR && selectedDriverDetails.length === 1"
        @click="invitePartners(true)"
        class="btn btn-primary"
      >
        Assign
      </button>
      <button
        v-else-if="!nullBackupTR"
        @click="invitePartners()"
        class="btn btn-primary"
      >
        Invite
      </button>
    </div>
  </div>
</template>

<script>
import SelectedBackupTR from './SelectedBackupTR.vue';
import http from '../../config/axios';

export default {
  components: { SelectedBackupTR },
  props: ['selectedDriverDetails'],
  data() {
    return {
      selectedBackupTR: JSON.parse(localStorage.getItem('selectedBackupTR')),
      backupRequestData: {},
      isLoading: false
    };
  },
  created() {
    this.generateBackupRequestData();
  },
  watch: {
    selectedBackupTR: {
      handler() {
        this.generateBackupRequestData();
        if (!this.selectedBackupTR) {
          this.$refs.modalCloseBtn.click();
        }
      },
      deep: true
    }
  },
  computed: {
    nullBackupTR() {
      let res = null;
      if (
        this.selectedBackupTR &&
        this.selectedBackupTR.length === 1 &&
        !this.selectedBackupTR[0].trip_request_id
      ) {
        res = this.selectedBackupTR[0];
      }
      return res;
    }
  },
  methods: {
    generateBackupRequestData() {
      this.backupRequestData = {};
      if (this.selectedBackupTR) {
        this.selectedBackupTR.forEach((element) => {
          this.backupRequestData[element.id] = {
            id: element.id,
            trip_request_id: element.trip_request_id,
            price: element.price,
            route_name: element.route_name,
            multiplier: null,
            total: null
          };
        });
      }
    },
    calculateTotal(key) {
      if (
        this.backupRequestData[key].multiplier &&
        this.backupRequestData[key].price
      ) {
        this.backupRequestData[key].total = (
          (this.backupRequestData[key].multiplier *
            parseFloat(this.backupRequestData[key].price)) /
            100 +
          parseFloat(this.backupRequestData[key].price)
        ).toFixed(4);
      } else {
        this.backupRequestData[key].total = null;
      }
    },
    calculateMultiplier(key) {
      if (
        this.backupRequestData[key].total &&
        this.backupRequestData[key].price
      ) {
        let extra =
          this.backupRequestData[key].total -
          parseFloat(this.backupRequestData[key].price);
        this.backupRequestData[key].multiplier = (
          (extra / parseFloat(this.backupRequestData[key].price)) *
          100
        ).toFixed(4);
      } else {
        this.backupRequestData[key].multiplier = null;
      }
    },
    syncBackupTRs(backupTRs) {
      this.selectedBackupTR = backupTRs;
      this.$emit('syncBackupTRs', backupTRs);
    },
    invitePartners(assignDriver = false) {
      let backupRequests = [];
      let selectedUsers = '';
      let selectedUserPhones = '';
      let noNullTotalPrice = true;

      for (const key in this.backupRequestData) {
        if (!this.backupRequestData[key].total) {
          noNullTotalPrice = false;
        }
        backupRequests.push(this.backupRequestData[key]);
      }
      this.selectedDriverDetails.forEach((driver, index) => {
        if (index === 0) {
          selectedUsers += driver.user_code;
          selectedUserPhones += driver.mobile;
        } else {
          selectedUsers += ',' + driver.user_code;
          selectedUserPhones += ',' + driver.mobile;
        }
      });

      if (noNullTotalPrice) {
        this.isLoading = true;
        http
          .post(`/v2/partners/backup/invite/drivers`, {
            backupRequests: backupRequests,
            driver_codes: selectedUsers,
            phones: selectedUserPhones,
            status: assignDriver ? 'Assigned' : 'Invited'
          })
          .then((response) => {
            this.isLoading = false;
            localStorage.removeItem('selectedBackupTR');
            localStorage.removeItem('searchDriverFromPartnerPage');
            this.$emit('syncBackupTRs', null);
            this.$emit('refreshData');
            this.$swal({
              icon: 'success',
              text: response.data.message
            });
            this.$refs.modalCloseBtn.click();
          })
          .catch((error) => {
            console.log(error.response);
            this.isLoading = false;
            this.$swal({
              icon: 'error',
              text: error.response.data.message
            });
          });
      } else {
        this.$swal({
          icon: 'warning',
          text: 'All total prices are mandatory!'
        });
      }
    }
  }
};
</script>

<style scoped>
.backup-tr-badge {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
}
.invite-backup-partner-table {
  box-shadow: 0px 2px 6px 4px rgba(0, 0, 0, 0.07);
  padding: 12px;
  border-radius: 4px;
  margin: 5px 0;
}
table {
  margin-bottom: 0;
}
tbody tr:last-child td {
  border-bottom: none;
}
.danger-value {
  background: rgba(255, 0, 0, 0.6);
}
</style>
